import React from 'react';
import { Select, Alert } from '../ui-kit';
import lodash from 'lodash';
import Loader from './Loader';
import TemplatePatternDetails from '../schedule/TemplatePatternDetails';
import { IconCircleInfo } from '../ui-kit/icons';

class TemplatePatternSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      templatePatterns: props.templatePatterns,
      selectedTemplatePattern: props.selectedTemplatePattern,
      showIntervalDetails: false
    };
  }

  selectedTemplatePatternId = () => (this.state.selectedTemplatePattern && this.state.selectedTemplatePattern.id) || '';

  selectedOption = () => {
    if (!this.state.selectedTemplatePattern) return null;
    return this.options().filter(o => this.state.selectedTemplatePattern.id === o.value);
  };

  filterOption = (op, filterValue) => op.data.textLabel.toLowerCase().includes(filterValue.toLowerCase());

  handleChange = events => {
    if (!Array.isArray(events)) events = [events].filter(Boolean);
    const values = new Set(events.map(e => e.value));
    this.setState(oldState => ({
      selectedTemplatePattern: oldState.templatePatterns.find(tp => values.has(Number(tp.id)))
    }));
  };

  options = () =>
    lodash.sortBy(Object.values(this.state.templatePatterns), ['name']).map(p => {
      const textLabel = p.name;
      const label = (
        <div>
          <span>{p.name}</span>
        </div>
      );
      return { value: p.id, textLabel, label };
    });

  render() {
    if (!this.state.templatePatterns) return <Loader />;
    return (
      <React.Fragment>
        <input type="hidden" name={this.props.inputName} value={this.selectedTemplatePatternId()} />
        <Select
          style={{ zIndex: '9999' }}
          value={this.selectedOption()}
          onChange={this.handleChange}
          options={this.options()}
          isClearable={true}
          isSearchable={true}
          className="react-select"
          filterOption={this.filterOption}
        />
        {this.state.selectedTemplatePattern && (
          <Alert variant="info" style={{ marginTop: '10px', marginBottom: '0' }}>
            <IconCircleInfo /> <TemplatePatternDetails pattern={this.state.selectedTemplatePattern} compact={true} />
          </Alert>
        )}
      </React.Fragment>
    );
  }
}

export default TemplatePatternSelector;
